import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment.prod";
import { MD5 } from 'crypto-js';

declare let fbq: Function;
declare let gtag: Function;
declare let snaptr: Function;
declare let ttq: any;
// var MD5 = require("crypto-js");
@Injectable({
    providedIn: "root",
})
export class MarketingService {
    confData: any;
    showMenuScrollButtons=false
    constructor(private http: HttpClient) {}

    initGTM(gtmId: any) {
        let scriptTag = document.createElement("script");
        scriptTag.text = `
        (function (w, d, s, l, i) {
          w[l] = w[l] || [];
          w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
          var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
          j.async = true;
          j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
          f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "${gtmId}");
      `;
        let noScriptTag = document.createElement("noscript");
        let iframeTag = document.createElement("iframe");
        iframeTag.setAttribute(
            "src",
            `https://www.googletagmanager.com/ns.html?id=${gtmId}`
        );
        iframeTag.setAttribute("height", "0");
        iframeTag.setAttribute("width", "0");
        iframeTag.setAttribute("style", "display: none; visibility: hidden");
        noScriptTag.append(iframeTag);

        document.getElementsByTagName("head")[0].appendChild(scriptTag);
        document.getElementsByTagName("body")[0].appendChild(noScriptTag);
    }

    initGoogleFeature(id: any) {
        let scriptTag = document.createElement("script");
        scriptTag.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
        scriptTag.async = true;
        document.getElementsByTagName("head")[0].appendChild(scriptTag);
    }

    initGoogleAnalytics(analyticsId: any) {
        let googleAnalytics = document.createElement("script");
        googleAnalytics.text = `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${analyticsId}');`;
        document.getElementsByTagName("head")[0].appendChild(googleAnalytics);
    }

       initGoogleConversion(googleConversionId: any) {
        let googleConversion = document.createElement("script");
        googleConversion.text = `window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${googleConversionId}');`;
        document.getElementsByTagName("head")[0].appendChild(googleConversion);
    }

    

    initHotJar(hotJarId: any) {
        let hotJar = document.createElement("script");
        hotJar.text = `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${hotJarId},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
        })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;
        document.getElementsByTagName("head")[0].appendChild(hotJar);
    }

    initFBPixel(pixelId: any) {
        let pixel = document.createElement("script");
        pixel.text = `
        !(function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(
        window,
        document,
        'script',
        'https://connect.facebook.net/en_US/fbevents.js'
      );
      fbq('init', '${pixelId}');`;

        document.getElementsByTagName("body")[0].appendChild(pixel);
    }

    initSnapPixel(pixelId: any) {
        let pixel = document.createElement("script");
        pixel.text = `(function(e,t,n){if(e.snaptr)return;var a=e.snaptr=function()
        {a.handleRequest?a.handleRequest.apply(a,arguments):a.queue.push(arguments)};
        a.queue=[];var s='script';r=t.createElement(s);r.async=!0;
        r.src=n;var u=t.getElementsByTagName(s)[0];
        u.parentNode.insertBefore(r,u);})(window,document,
        'https://sc-static.net/scevent.min.js');

        snaptr('init', '${pixelId}', {
        'user_email': '__INSERT_USER_EMAIL__'
        });

        snaptr('track', 'PAGE_VIEW');
        `;

        document.getElementsByTagName("body")[0].appendChild(pixel);
    }

  initTiktokPixel(pixelId :any) {
    const script = document.createElement("script");
    script.text = `
      !function(w, d, t) {
        w.TiktokAnalyticsObject = t;
        var ttq = w[t] = w[t] || [];
        ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie"];
        ttq.setAndDefer = function(t, e) {
          t[e] = function() {
            t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
          };
        };
        for (var i = 0; i < ttq.methods.length; i++) {
          ttq.setAndDefer(ttq, ttq.methods[i]);
        }
        ttq.instance = function(t) {
          var e = ttq._i[t] || [];
          for (var n = 0; n < ttq.methods.length; n++) {
            ttq.setAndDefer(e, ttq.methods[n]);
          }
          return e;
        };
        ttq.load = function(e, n) {
          var i = "https://analytics.tiktok.com/i18n/pixel/events.js";
          ttq._i = ttq._i || {};
          ttq._i[e] = [];
          ttq._i[e]._u = i;
          ttq._t = ttq._t || {};
          ttq._t[e] = +new Date;
          ttq._o = ttq._o || {};
          ttq._o[e] = n || {};
          n = document.createElement("script");
          n.type = "text/javascript";
          n.async = !0;
          n.src = i + "?sdkid=" + e + "&lib=" + t;
          e = document.getElementsByTagName("script")[0];
          e.parentNode.insertBefore(n, e);
        };
        ttq.load('${pixelId}');
        ttq.page();
      }(window, document, 'ttq');
    `;
    document.head.appendChild(script);
  }


  initCriteoq(profile: any, vistorId: any, event: any, itemData?:any) {
  // Create a new script element
  const script = document.createElement('script');
  script.type = 'text/javascript';

  // Determine the email based on the profile and visitor ID
  const email = profile?.email ? MD5(profile.email).toString() : MD5(vistorId + '_guest@zahranstores.com').toString();

  // Determine the device type for the pixel
  const deviceType = /iPad/.test(navigator.userAgent) ? 't' : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? 'm' : 'd';

  let eventScript = '';

  // Create the appropriate event script based on whether there's item data or not
  if (itemData && itemData?.length > 0) {
    eventScript = `
      window.criteo_q.push(
        { event: "setAccount", account: 104978 },
        { event: "setEmail", email: "${email}", hash_method: "md5" },
        { event: "setSiteType", type: "${deviceType}" },
        { event: "${event}", item: ${JSON.stringify(itemData)} },
        ${profile ? `{ event: "setCustomerId", id: "${profile.id}" }` : `{ event: "setRetailerVisitorId", id: "${vistorId}"}`}
      );
    `;
  } else {
    eventScript = `
      window.criteo_q.push(
        { event: "setAccount", account: 104978 },
        { event: "setEmail", email: "${email}", hash_method: "md5" },
        { event: "setSiteType", type: "${deviceType}" },
        { event: "${event}" },
        ${profile ? `{ event: "setCustomerId", id: "${profile.id}" }` : `{ event: "setRetailerVisitorId", id: "${vistorId}"}`}
      );
    `;
  }

  // Set the innerHTML of the script element and append it to the document body
  script.innerHTML = eventScript;
  document.body?.appendChild(script);
}
// document.head.appendChild(pixel);
// }


// Usage


  ttqTracking(event: string = 'track', option: string, data: any = {}) {
    ttq?.track(option, {data} );
  }
    
    addMetaTags(name: any, value: any, attr?: any) {
        var meta = document.createElement("meta");
        if (attr) {
            meta.setAttribute(attr, name);
        } else {
            meta.name = name;
        }
        meta.content = value;
        document.getElementsByTagName("head")[0].appendChild(meta);
    }

    conversionApi() {
        let data = { view_type: "initiate_checkout" };
        return this.http.post<any>(
            `${environment.api}/api/customer/view/page`,
            data
        );
    }

    fbTracking(event: string = "track", option: string, data: any = {}) {
        if (typeof fbq !== "undefined") fbq(event, option, data);
    }
    snapTracking(event: string = "track", option: string, data: any = {}) {
       if (typeof snaptr !== "undefined")   snaptr(event, option, data);
    }
    
    googleConversionConfig(
        event_name: string = "config",
        conversion_ID: string
    ) {
        if (typeof gtag !== "undefined") gtag(event_name, conversion_ID);
    }
    googleConversionTracking(
        event_name: string = "conversion",
        conversion_ID: string,
        conversion_Label: string,
        transaction_ID: string = ""
    ) {
        if (typeof gtag !== "undefined")
            gtag("event", event_name, {
                send_to: `${conversion_ID}${
                    conversion_Label ? `/${conversion_Label}` : ""
                }`,
                transaction_id: transaction_ID,
            });
    }

    cartEvents(event: string, product: any, action: string = "add") {
        let CartlayerData = {
            event: event,
            ecommerce: {
                currencyCode: "EGP",
                [action]: {
                    products: [
                        {
                            name: product.name,
                            id: product.id,
                            price: product.discount_price
                                ? product.discount_price
                                : product.price,
                            brand:
                                product.details && product.details.brand
                                    ? product.details.brand.name
                                    : "",
                            category: product.category
                                ? product.category.name
                                : "-",
                            quantity: 1,
                        },
                    ],
                },
            },
        };
        window["dataLayer"]?.push(CartlayerData);
    }

    checkoutEvents(event: string, products: any, step: number, option: string) {
        let productsData: any = [];
        products.forEach((data: any) => {
            productsData.push({
                name: data.name,
                id: data.id,
                price: data.discount_price ? data.discount_price : data.price,
                brand:
                    data.details && data.details.brand
                        ? data.details.brand.name
                        : "",
                category: data.category ? data.category.name : "-",
                quantity: data.amount,
            });
        });
        let CheckoutData = {
            event: event,
            ecommerce: {
                checkout: {
                    actionField: { step: step, option: option },
                    products: productsData,
                },
            },
        };
        window["dataLayer"]?.push(CheckoutData);
    }

    purchaseEvent(products: any) {
        let productsData: any = [];
        products?.items.forEach((data: any) => {
            productsData.push({
                name: data.name,
                id: data.id,
                price: data.discount_price ? data.discount_price : data.price,
                brand:
                    data.details && data.details.brand
                        ? data.details.brand.name
                        : "",
                category: data.category ? data.category.name : "-",
                quantity: data.amount,
            });
        });
        let purchaseData = {
            ecommerce: {
                purchase: {
                    actionField: {
                        id: products?.id, // Transaction ID. Required for purchases and refunds.
                        revenue: products?.total, // Total transaction value (incl. tax and shipping)
                        shipping: products?.delivery_fees,
                    },
                    products: productsData,
                },
            },
        };
        window["dataLayer"]?.push(purchaseData);
    }

    productClickEvent(event: string, product: any) {
        let productData = {
            event: event,
            ecommerce: {
                click: {
                    actionField: { list: "Search Results" }, // Optional list property.
                    products: [
                        {
                            name: product.name, // Name or ID is required.
                            id: product.id,
                            price: product.discount_price
                                ? product.discount_price
                                : product.price,
                            brand:
                                product.details && product.details.brand
                                    ? product.details.brand.name
                                    : "",
                            category: product.category
                                ? product.category.name
                                : "-",
                        },
                    ],
                },
            },
        };
        window["dataLayer"]?.push(productData);
    }



  GA4SingleProductEvent(event:any, product:any){
    gtag("event", event, {
      currency: "EGP",
      value: product.discount_price || product.price,
      items: [
        {
          item_id: product.id,
          item_name: product.name,
          currency: "EGP",
          discount: (product.discount_price ? (product.price - product.discount_price) : 0),
          item_category: product?.category?.name,
          item_category2: product?.category?.sub_categories[0]?.name,
          price: product.price,
          quantity: product.amount
        }
      ]
    });
  }
  
  GA4MultiProductsEvent(event:any, products:any, paymentType = null){
    let items = products.map((product:any) => {
      return {
        item_id: product.id,
        item_name: product.name,
        currency: "EGP",
        discount: (product.discount_price ? (product.price - product.discount_price) : 0),
        item_category: product?.category?.name,
        item_category2: product?.category?.sub_categories[0]?.name,
        price: product.price,
        quantity: product.amount
      };
    });
    let total = 0;
    products.forEach((product:any) => {
      total = total + (product.discount_price || product.price);
    });
    gtag("event", event, {
      currency: "EGP",
      value: total,
      items: items
    });
  }

  GA4Seach(searchTerm:any){
    gtag("event", "search", {
      search_term: searchTerm
    });
  }

  GA4PurchaseEvent(order:any){
    let items = order?.items.map((product:any) => {
      return {
        item_id: product.id,
        item_name: product.name,
        currency: "EGP",
        discount: (product.discount_price ? (product.price - product.discount_price) : 0),
        item_category: product?.category?.name,
        item_category2: product?.category?.sub_categories[0]?.name,
        price: product.price,
        quantity: product.amount
      };
    });
    if (typeof gtag !== "undefined") {
      gtag("event", 'purchase', {
        transaction_id: order?.invoice?.order_id,
        value: order?.invoice?.discount !== null
          ? order?.invoice.discount
          : order?.invoice.total_amount,
        shipping: order?.invoice?.delivery_fees,
        currency: "EGP",
        items: items
      });
    }
  }

  GA4SignUpEvent(){
    gtag("event", 'sign_up',{});
  }

  GA4SelectContentEvent(data :IGA4SelectContentEvent){ 
    gtag("event", 'select_content', {
      items: [data]
    });
  }
  GA4MenuClickNavigationLevelEvent(levelUrl = ''){
    let navLevel = {
      nav_level: levelUrl
    }
    gtag("event", 'click_navigation',navLevel);
  }

  GA4ClickCarouselEvent(data:IGA4ClickCarousel){
     gtag("event", 'carousel_click',data);
  }
  GA4ViewCartEvent(data:IGA4ViewCartEvent){
     gtag("event", 'view_cart',{
      items: [data]
    });
  }
  GA4AddToWishlistEvent(data:IG4AFullProduct){
     gtag("event", 'add_to_wishlist',
     {
       items: [data]
     });
  }
  GA4AddToCartEvent(data:IGA4ProductEvent){
     gtag("event", 'add_to_cart',{
      items: [data]
    });
  }
  GA4QuickAddToCartEvent(data:IGA4ProductEvent){
     gtag("event", 'quick_add_to_cart',{
      items: [data]
    });
  }

  GA4RemoveFromCartEvent(data:IGA4ProductEvent){
     gtag("event", 'remove_from_cart',{
      items: [data]
    });
  }
  GA4PromotionClickEvent(data:IGA4PromotionClickEvent){
     gtag("event", 'promotion_click',data);
  }
  GA4BeginCheckoutEvent(data:IG4AFullProduct){
     gtag("event", 'begin_checkout',data);
  }
  GA4addPaymentInfoEvent(data:IG4AFullProduct){
     gtag("event", 'add_payment_info',data);
  }
  
}


 
interface IGA4PromotionClickEvent {
  promotion_id:string,
  promotion_name:string,
  promotion_position:string,
  promotion_type:string,
}
interface IGA4ProductEvent {
  value:string,
  item_id:string,
  item_name:string,
  currency:string,
  discount:string,
  price:string,
  quantity:string,
}
interface IG4AFullProduct {
  currency:string,
  value:string,
  item_id:string,
  item_name:string,
  discount:string,
  item_category:string,
  item_category2:string,
  price:string,
  quantity:string,
  payment_type?:string // in event add_payment_info 
}
interface IGA4ViewCartEvent {
  currency:string,
  value:string,
}
interface IGA4SelectContentEvent {
  content_type:string,
  item_id:string,
  item_name:string,
}
interface IGA4ClickCarousel {
  content_name:string,
  carousel_action:string,
  position:string,
}
